import { useParams } from "react-router-dom";

export default function CardDepartamentos({ icone, nomeService, fase }) {
  const { status } = useParams();
  const isActive = fase === status;

  return (
    <div
      className={[
        'tw-flex tw-flex-col tw-items-center tw-justify-center',
        'tw-min-w-[100px] tw-w-[16%] tw-py-4 tw-px-3',
        'tw-border tw-border-[#85287e]/40 tw-rounded-[10px]',
        'tw-transition-all tw-duration-500',
        isActive
          ? 'tw-bg-[#b1b7ea] tw-scale-110 tw-shadow-md tw-border-[#85287e]'
          : 'tw-bg-white hover:tw-bg-[#85287e]/5',
      ].join(' ')}
    >
      <img src={icone} alt={nomeService} className="tw-h-[70px] tw-object-contain tw-mb-2" />
      <p className="tw-text-[13px] tw-text-center tw-leading-snug tw-text-gray-700 tw-font-medium">
        {nomeService}
      </p>
    </div>
  );
}
